export default __webpack_public_path__ + "static/media/img8.ecf68a9b.png";